module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DialogBox', {
    attrs: {
      "settings": _vm.settings
    },
    on: {
      "show": _vm.initialiseDialog
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.programItems
    },
    model: {
      value: (_vm.program),
      callback: function($$v) {
        _vm.program = $$v
      },
      expression: "program"
    }
  }), _vm._v(" "), (_vm.program == 'tc') ? _c('v-text-field', {
    attrs: {
      "label": "Contact Key"
    },
    model: {
      value: (_vm.contactKey),
      callback: function($$v) {
        _vm.contactKey = $$v
      },
      expression: "contactKey"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.program == 'tot') ? _c('v-text-field', {
    attrs: {
      "label": "Template Key"
    },
    model: {
      value: (_vm.templateKey),
      callback: function($$v) {
        _vm.templateKey = $$v
      },
      expression: "templateKey"
    }
  }) : _vm._e(), _vm._v(" "), (this.program == 'tcu' || this.program == 'ttu') ? _c('UserChooser', {
    attrs: {
      "label": "User"
    },
    model: {
      value: (_vm.user),
      callback: function($$v) {
        _vm.user = $$v
      },
      expression: "user"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.tenants,
      "item-text": "name",
      "item-value": "meta.key",
      "label": "Source Tenant"
    },
    model: {
      value: (_vm.sourceTenant),
      callback: function($$v) {
        _vm.sourceTenant = $$v
      },
      expression: "sourceTenant"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.tenants.filter(function (o) { return o.meta.key != _vm.sourceTenant; }),
      "item-text": "name",
      "item-value": "meta.key",
      "label": "Destination Tenant"
    },
    model: {
      value: (_vm.destinationTenant),
      callback: function($$v) {
        _vm.destinationTenant = $$v
      },
      expression: "destinationTenant"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "primary",
      "label": "Remove from Source"
    },
    model: {
      value: (_vm.move),
      callback: function($$v) {
        _vm.move = $$v
      },
      expression: "move"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Simulate Writes"
    },
    model: {
      value: (_vm.simulateWrites),
      callback: function($$v) {
        _vm.simulateWrites = $$v
      },
      expression: "simulateWrites"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Simulate Deletes"
    },
    model: {
      value: (_vm.simulateDeletes),
      callback: function($$v) {
        _vm.simulateDeletes = $$v
      },
      expression: "simulateDeletes"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.run
    }
  }, [_vm._v("Go")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Results"
    },
    model: {
      value: (_vm.output),
      callback: function($$v) {
        _vm.output = $$v
      },
      expression: "output"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ada4ca8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/MaintenanceDialog.vue
// module id = 2471
// module chunks = 1